import { Lang } from 'Roblox';
import avatarModule from '../avatarModule';

function avatarScaleService(avatarConstantService) {
  'ngInject';

  function applyScaleConstraints(scaleRule, scale) {
    scale.min = scaleRule.min * 100;
    scale.max = scaleRule.max * 100;
  }

  return {
    scales: {
      height: {
        label: avatarConstantService.bodyScaling.height,
        min: 0,
        max: 100,
        value: 100,
        increment: 5,
        type: avatarConstantService.bodyScalingType.height
      },
      width: {
        label: avatarConstantService.bodyScaling.width,
        min: 0,
        max: 100,
        value: 100,
        increment: 5,
        type: avatarConstantService.bodyScalingType.width
      },
      head: {
        label: avatarConstantService.bodyScaling.head,
        min: 0,
        max: 100,
        value: 100,
        increment: 5,
        type: avatarConstantService.bodyScalingType.head
      }
    },
    getScales() {
      return this.scales;
    },
    applyCurrentScale(avatarDetails, scaleProportionAndBodyTypeEnabled) {
      this.scales.height.value = avatarDetails.scales.height * 100;
      this.scales.width.value = avatarDetails.scales.width * 100;
      this.scales.head.value = avatarDetails.scales.head * 100;
      if (scaleProportionAndBodyTypeEnabled) {
        this.scales.proportion.value = avatarDetails.scales.proportion * 100;
        this.scales.bodyType.value = avatarDetails.scales.bodyType * 100;
      }
    },
    updateScales(newVal, scaleProportionAndBodyTypeEnabled) {
      this.scales.height.value = newVal.height.value;
      this.scales.width.value = newVal.width.value;
      this.scales.head.value = newVal.head.value;

      if (scaleProportionAndBodyTypeEnabled) {
        this.scales.proportion.value = newVal.proportion.value;
        this.scales.bodyType.value = newVal.bodyType.value;
      }
    },
    initializeScaleMetrics(
      avatarRules,
      metaData,
      scaleProportionAndBodyTypeEnabled,
      isI18nEnabledForAvatar
    ) {
      if (scaleProportionAndBodyTypeEnabled) {
        this.scales.bodyType = {
          label: Lang.AvatarResources['Label.BodyType'],
          min: 0,
          max: 100,
          value: 0,
          increment: 5,
          type: avatarConstantService.bodyScalingType.bodyType
        };
        this.scales.proportion = {
          label: avatarConstantService.bodyScaling.proportions,
          min: 0,
          max: 100,
          value: 0,
          increment: 5,
          type: avatarConstantService.bodyScalingType.proportions
        };
      }

      // website has custom increments
      this.scales.height.increment = metaData.scaleHeightIncrement * 100;
      this.scales.width.increment = metaData.scaleWidthIncrement * 100;
      this.scales.head.increment = metaData.scaleHeadIncrement * 100;

      // update mins, maxes, and increments first
      applyScaleConstraints(avatarRules.scales.height, this.scales.height);
      applyScaleConstraints(avatarRules.scales.width, this.scales.width);
      applyScaleConstraints(avatarRules.scales.head, this.scales.head);
      if (scaleProportionAndBodyTypeEnabled) {
        applyScaleConstraints(avatarRules.scales.proportion, this.scales.proportion);
        applyScaleConstraints(avatarRules.scales.bodyType, this.scales.bodyType);
      }
    }
  };
}

avatarModule.factory('avatarScaleService', avatarScaleService);

export default avatarScaleService;
